export default __webpack_public_path__ + "static/media/FAQ-1.ea89aad8.png";